/**
 * Renders a list of validation messages under a "Blocking Reason(s)" header,
 * each on its own line prefixed by a bullet.
 *
 * Intended for tooltips and banners that explain why an action is blocked.
 *
 * @module validationMessageList
 */
import React from "react";

interface ValidationMessageListProps {
  /** One message per line. */
  messages: string[];
}

/**
 * Renders each message on a new line with a bullet prefix.
 *
 * @param props.messages - Validation messages to display
 * @returns The bulleted message list
 */
const ValidationMessageList: React.FC<ValidationMessageListProps> = ({
  messages,
}) => {
  return (
    <div className="flex max-w-[25rem] flex-col gap-1.5">
      <p className="text-xs font-semibold">Blocking Reason(s)</p>
      <ul className="flex flex-col gap-1 pl-3">
        {messages.map((message) => (
          <li key={message} className="flex items-start gap-1.5">
            <span className="mt-[0.45rem] h-1 w-1 shrink-0 rounded-full bg-current" />
            <span>{message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ValidationMessageList;
